// @ts-nocheck
import * as React from "react";
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/scss/pagination";
import "swiper/css/navigation";

// Components
import Loader from "../Loader";
import ContentCarousel from "../contentCarousel";
import Banner from "../Banner";
import { FishSec } from "../Animals";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

export const Allies = ({ data, setLoading, loading }: AlliesCmp) => {

    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [openIsModal, setopenIsModal] = React.useState<boolean>(false)
    const [infoModal, setinfoModal] = React.useState<string>('')
    const [activeSection, setActiveSection] = React.useState<number>(0)

    const openModal = (modalInfo: any): void => {
        setopenIsModal(true)
        setinfoModal(modalInfo)
        if (openIsModal) bodyElm.style.overflow = 'hidden'
    }
    const closeModal = () => {
        setopenIsModal(false)
        if (!openIsModal) bodyElm.style.overflow = 'initial'
    }

    const changeSection = (index: number) => {
        setActiveSection(index)
    }

    const onSwiperChangeMob = (indexTab) => {
        if ((window.matchMedia("(max-width: 623px)").matches)) {
            setActiveSection(indexTab)
        }
    }

    React.useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    }, []);

    return (
        <section className='boxAllies'>
            <Banner
                backImage={{ desk: `/${THEMEURL}/sources/dist/assets/images/allies/aliadosDesktop.jpg`, mobile: `/${THEMEURL}/sources/dist/assets/allies/aliadosMobile.jpg` }}
                textBanner={!loading ? data.title : ''}
                textDescription={data.desc_head}
            />
            <div className="boxAllies__content">
                {/* <FishSec /> */}
                <div className="boxAllies__content--top" data-aos='fade-up' data-aos-anchor-placement='bottom-bottom'>
                    <Swiper
                        modules={[Navigation]}
                        spaceBetween={20}
                        slidesPerView={1}
                        id='topAllies'
                        navigation={{
                            prevEl: navigationPrevRef.current,
                            nextEl: navigationNextRef.current,
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                        }}
                        onSlideChange={(swiper) => {
                            onSwiperChangeMob(swiper.activeIndex)
                        }}
                        onSwiper={(swiper) => {
                            // Delay execution for the refs to be defined
                            setTimeout(() => {
                                // Override prevEl & nextEl now that refs are defined
                                swiper.params.navigation.prevEl = navigationPrevRef.current
                                swiper.params.navigation.nextEl = navigationNextRef.current

                                // Re-init navigation
                                swiper.navigation.destroy()
                                swiper.navigation.init()
                                swiper.navigation.update()
                            })
                        }}
                    >
                        {data.tabs.map(({ titlemain }: AlliesCard, indexButton: number) => (
                            <SwiperSlide key={indexButton}>
                                <div className={`btnTabs${indexButton == activeSection ? ' active' : ''}`} onClick={() => changeSection(indexButton)}>{titlemain}</div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div ref={navigationPrevRef} className="swiper-button-prev" />
                    <div ref={navigationNextRef} className="swiper-button-next" />
                </div>
                <div className="boxAllies__content--body" data-aos='fade-up' data-aos-anchor-placement='center-bottom'>
                    {data.tabs.map(({ targetlist }: AlliesCard, indexContent: number) => (
                        <div key={indexContent} className={`boxTabs${indexContent == activeSection ? ' active' : ''}`} >
                            <Swiper
                                modules={[Pagination]}
                                spaceBetween={10}
                                slidesPerView={1}
                                speed={800}
                                id='sliderAllies'
                                pagination={{ "clickable": true }}
                                breakpoints={{
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 20,
                                    },
                                    1280: {
                                        slidesPerView: 3,
                                        spaceBetween: 30,
                                    }
                                }}
                            >

                                {targetlist && targetlist.map((card: AlliesTarget, indexCard: number) => (
                                    <SwiperSlide key={indexCard}>
                                        <ContentCarousel
                                            imgUrl={card.imagelogo}
                                            title={card.title}
                                            description={card.description}
                                            openModal={openModal}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    ))}
                </div>
            </div>
            <div className={`Popup ${openIsModal ? 'active' : ''}`}>
                <div className="Popup__container">
                    <img className="closePopup" onClick={closeModal} src={`/${THEMEURL}/sources/dist/assets/images/allies/closePopup.png`} alt="" />
                    <div className="Popup__container--img">
                        {infoModal && <img src={infoModal.imgUrl.url} alt={infoModal.imgUrl.alt} title={infoModal.imgUrl.alt} />}
                    </div>
                    <div className="Popup__container--title">{`${infoModal.title}`}</div>
                    <div className="Popup__container--desc">{`${infoModal.description}`}</div>
                </div>
            </div>
        </section>

    )
}

export default Loader(Allies)